<template>
  <div class="container search-content-bottom">
    <section
      v-if="isSeoPage"
      id="regionInfo"
    >
      <tiptap-container
        container-key="searchContentBottom"
        :default-content="content.text2"
      />
    </section>

    <section v-if="favoriteRegions.length && (isSeaPage || isSeoPage)">
      <content-link-list
        :list-title="$t('search:popularRegions.title', {name: locationNameWithPreposition})"
        :list-more="$t('search:popularRegions.more')"
        :list-elements="favoriteRegions"
      />
    </section>

    <section v-if="favoritePlaces.length && (isSeaPage || isSeoPage)">
      <content-link-list
        :list-title="$t('search:popularPlaces.title', {name: locationNameWithPreposition})"
        :list-more="$t('search:popularRegions.more')"
        :list-elements="favoritePlaces"
      />
    </section>

    <section v-if="favoriteOffers.length && (isSeaPage || isSeoPage)">
      <content-link-list
        :list-title="$t('search:offers.title', {name: locationName})"
        :list-more="$t('search:offers.more')"
        :list-elements="favoriteOffers"
      />
    </section>
  </div>
</template>

<script>
import ContentLinkList from 'components/ContentLinkList.vue';
import TiptapContainer from 'components/tiptap/TiptapContainer.vue';
import StateProviderSetup from 'mixins/composition/search/StateProvider';
import { getReducedCtx } from 'mixins/composition/search/index';

export default {
  i18nOptions: { namespaces: 'search' },
  components: {
    ContentLinkList,
    TiptapContainer,
  },
  props: {
    content: {
      type: Object,
      default() { return {}; },
    },
  },
  setup(props, ctx) {
    const {
      isSeoPage, isSeaPage, locationNameWithPreposition, locationName
    } = StateProviderSetup(getReducedCtx(ctx));

    return {
      isSeoPage,
      isSeaPage,
      locationNameWithPreposition,
      locationName
    };
  },
  computed: {
    favoriteRegions() {
      const regions = [];
      if (this.content.topLinks.regions) {
        Object.entries(this.content.topLinks.regions).forEach((el) => {
          regions.push({ title: el[0], href: el[1] });
        });
      }
      return regions;
    },
    favoritePlaces() {
      const places = [];
      if (this.content.topLinks.places) {
        Object.entries(this.content.topLinks.places).forEach((el) => {
          places.push({ title: el[0], href: el[1] });
        });
      }
      return places;
    },
    favoriteOffers() {
      const offers = [];
      if (this.content.offers) {
        Object.values(this.content.offers).forEach((el) => {
          offers.push({ title: el.name, href: el.seoUrl });
        });
      }
      return offers;
    },
  },
};
</script>
